import { render, staticRenderFns } from "./ProjectsArchivedPage.vue?vue&type=template&id=231e1998&lang=pug&"
import script from "./ProjectsArchivedPage.vue?vue&type=script&lang=js&"
export * from "./ProjectsArchivedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports